<template>
  <v-footer dark app>
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-actions class="justify-center">
        &copy; 2019 — Up ski & mountain guides
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data () {
    return {
      fixed: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// PageFooter.vue?94def8ee